var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SoliForm", {
    ref: "form",
    attrs: {
      title: _vm.currentStep.hideTitle ? null : _vm.title,
      hideBtn: !_vm.isFinalStep,
      lowTitle: _vm.lowTitle,
      showCancelBtn: !_vm.currentStep.hideCancelBtn,
      selection: _vm.selection,
      limitScroll:
        !_vm.currentStep.hideProgress &&
        !_vm.continueBtn.show &&
        !_vm.saveBtn.show &&
        !_vm.$vuetify.breakpoint.xs
          ? true
          : null,
      cardBody: !_vm.isFinalStep && _vm.cardBody,
      extraBtn: _vm.continueBtn.show || _vm.saveBtn.show,
      loadingProp: _vm.formLoadingProp,
      mobileScroll: _vm.$vuetify.breakpoint.xs && !_vm.relative,
      persistent: "",
      flat: _vm.flat,
      relative: _vm.relative,
      permanent: _vm.permanent,
      text: "Book it!",
      icon: "music_note",
    },
    on: {
      findChip: function ($event) {
        return _vm.jumpToStep($event)
      },
      success: function ($event) {
        return _vm.$emit("success")
      },
      reset: function ($event) {
        return _vm.$emit("reset")
      },
      submit: _vm.submit,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "header",
          fn: function () {
            return [_vm._t("header")]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function () {
            return [
              !_vm.currentStep.hideProgress
                ? _c(
                    "div",
                    { staticClass: "flex align-center py-3 px-4 soli-grey" },
                    [
                      _c(
                        "v-progress-circular",
                        {
                          staticClass: "flex-shrink-0 mr-5",
                          attrs: {
                            value: _vm.progressVal,
                            rotate: 180,
                            size: 55,
                            color: "#228cbd",
                            width: "5",
                            indeterminate: _vm.apiLoading,
                          },
                        },
                        [
                          !_vm.apiLoading
                            ? _c("div", [_vm._v(_vm._s(_vm.stepNumber))])
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.apiLoading
                        ? _c(
                            "div",
                            { staticStyle: { "text-align": "start" } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.currentStep.title()) +
                                  "\n                "
                              ),
                              _c(
                                "small",
                                {
                                  staticClass: "flex",
                                  staticStyle: { "text-align": "start" },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.currentStep.subText) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.apiLoading
                        ? _c("v-skeleton-loader", {
                            attrs: { width: "245", type: "list-item" },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.apiLoading
                ? _c(
                    "v-stepper",
                    {
                      staticClass: "elevation-0",
                      class: [
                        _vm.currentStep.scrollTime && !!_vm.currentStep.value()
                          ? "scrollTimes"
                          : null,
                        _vm.currentStep.hideProgress && !_vm.isFinalStep
                          ? "py-3"
                          : null,
                      ],
                      model: {
                        value: _vm.stepNumber,
                        callback: function ($$v) {
                          _vm.stepNumber = $$v
                        },
                        expression: "stepNumber",
                      },
                    },
                    _vm._l(_vm.selectableOptions, function (step) {
                      return _c(
                        "div",
                        { key: step.name },
                        [
                          _c(
                            "v-stepper-content",
                            {
                              staticClass: "pa-0",
                              attrs: {
                                step: _vm.selectableOptions.indexOf(step) + 1,
                              },
                            },
                            [_vm._t(step.name)],
                            2
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.apiLoading
                ? _c("v-skeleton-loader", {
                    staticClass: "mx-auto",
                    attrs: {
                      "max-width": "300",
                      type: "list-item, list-item, list-item",
                    },
                  })
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "cancelBtn",
          fn: function (attrs) {
            return [
              _vm.continueBtn.show && !_vm.isFinalStep
                ? _c(
                    "SoliBtn",
                    _vm._b(
                      {
                        staticClass: "mt-3",
                        attrs: {
                          disabled: _vm.continueBtn.disabled,
                          loading: _vm.continueBtn.loading,
                          text: "Continue",
                          gradient: "gradient-orange",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("continueBtn")
                          },
                        },
                      },
                      "SoliBtn",
                      attrs,
                      false
                    )
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.saveBtn.show && !_vm.isFinalStep
                ? _c(
                    "SoliBtn",
                    _vm._b(
                      {
                        staticClass: "mt-3",
                        attrs: {
                          disabled: _vm.saveBtn.disabled,
                          text: "Continue",
                          gradient: "gradient-orange",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("saveInnerForm")
                          },
                        },
                      },
                      "SoliBtn",
                      attrs,
                      false
                    )
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentStep.payment
                ? _c(
                    "SoliBtn",
                    _vm._b(
                      {
                        staticClass: "mt-3",
                        attrs: {
                          loading: _vm.paymentBtn.loading,
                          text: "Book It!",
                          icon: "music_note",
                          gradient: "gradient-orange",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("paymentBtn")
                          },
                        },
                      },
                      "SoliBtn",
                      attrs,
                      false
                    )
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isFirstStep
                ? _c(
                    "SoliBtn",
                    _vm._b(
                      {
                        staticClass: "mt-3",
                        attrs: {
                          text: "Back a step",
                          icon: "chevron_left",
                          left: "",
                          color: "grey",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("backStep")
                          },
                        },
                      },
                      "SoliBtn",
                      attrs,
                      false
                    )
                  )
                : _vm._e(),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }